// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"BasicFormSelect_inputContainer__3M_HD","input":"BasicFormSelect_input__3zuth","option":"BasicFormSelect_option__3Rmls","label":"BasicFormSelect_label__12vKU"};